<template>
  <div class="main-table">
    <h3 class="table-note">Choose a category, then click a value.</h3>
    <img
      class="bg-image"
      src="@/assets/images/second-bg.png"
      alt="image description"
      aria-hidden="true"
    />
    <div class="table-holder">
      <table>
        <thead>
          <tr>
            <th
              v-for="field in fields"
              :key="field.categoryName"
              v-html="field.categoryName"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(items, rowIndex) in fields[0].items" :key="items">
            <td
              v-for="field in fields"
              :key="field"
              :class="field.items[rowIndex].isRevealed ? 'active' : ''"
              @click.stop="
                openAnswer(
                  {
                    categoryID: field.categoryID,
                    scores: field.items[rowIndex].scores,
                  },
                  $event, field.items[rowIndex].isRevealed
                )
              "
            >
              <span
                v-html="field.items[rowIndex].questionText"
                class="table__text"
              ></span>
              <span
                v-html="field.items[rowIndex].scores"
                class="table__scores"
              ></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-right btn-holder">
      <AppButton class="btn-next" @click.prevent="goToStep(4)"
        ><span>End game</span></AppButton
      >
    </div>
  </div>
  <transition
    v-on:before-enter="beforeEnter"
    v-on:before-leave="beforeLeave"
    v-on:leave="leave"
    name="scale"
  >
    <AppAnswer v-if="isAnswerActive" />
  </transition>
</template>

<script>
import { gsap } from "gsap";
import { mapGetters, mapMutations } from "vuex";

import AppAnswer from "@/components/Answer";

export default {
  name: "MainTable",
  components: {
    AppAnswer,
  },
  computed: {
    ...mapGetters({
      fields: "getBlocks",
      isAnswerActive: "getAnswerState",
      answPos: "getAnswerPos",
    }),
  },
  methods: {
    ...mapMutations({
      showAnswer: 'goToAnswer',
        play: 'play',
        getAnswrObj: 'updateAnswerPos',
        goToStep: 'goToStep',
        stop: 'stop',
      getTableHeight() {
        const mainTable = document.querySelector(".main-table table");

        mainTable.style.height = `${window.innerHeight - 100 - 97 - 51 - 110}px`;
      },
    }),
    openAnswer(obj, event, isRevealed) {
      const curBox = event.target;
      const clientRects = curBox.getBoundingClientRect();
      const tempObj = {
        left: clientRects.left,
        top: clientRects.top,
        width: clientRects.width,
        height: clientRects.height,
      };

      document.body.classList.add("answer-active");
      this.getAnswrObj(tempObj);
      this.showAnswer(obj);
      if (isRevealed) {
        document.body.classList.add("quest-active");
      } else {
        document.body.classList.remove("quest-active");
      }
      this.play('question_reveal');
    },
    // transition callbacks
    beforeEnter: function (el) {
      gsap.fromTo(
        el,
        {
          x: `${this.answPos.left + this.answPos.width / 2}px`,
          y: `${this.answPos.top + this.answPos.height / 2}px`,
          scaleX: 0,
          scaleY: 0,
        },
        { x: 0, y: 0, scaleX: 1, scaleY: 1, duration: 0.5 }
      );
      setTimeout(() => {}, 300);
    },
    beforeLeave: function (el) {
      gsap.fromTo(
        el,
        { x: 0, y: 0, scaleX: 1, scaleY: 1 },
        {
          x: `${this.answPos.left + this.answPos.width / 2}px`,
          y: `${this.answPos.top + this.answPos.height / 2}px`,
          scaleX: 0,
          scaleY: 0,
          duration: 0.35,
        }
      );
    },
    leave: function (el, done) {
      setTimeout(() => done, 500);
    },
  },
  mounted() {
    setTimeout(() => {
      this.getTableHeight();
      setTimeout(() => window.dispatchEvent(new Event("resize")), 500);
    }, 100);
    window.addEventListener("resize", this.getTableHeight);
  },
  unmounted() {
    window.removeEventListener("resize", this.getTableHeight);
  },
};
</script>
